import { getMtoDeliveryDate } from '~/js/lib/date';

export default (node) => {
  const mtoDeliveryDateNode = node.matches && node.matches('[data-mto-delivery-date]')
    ? node
    : node.querySelector('[data-mto-delivery-date]');

  const setMtoDeliveryDate = () => {
    const isUS = mtoDeliveryDateNode.dataset.region === 'US';
    const deliveryTime = isUS ? mtoDeliveryDateNode.dataset.deliveryTimeUs : mtoDeliveryDateNode.dataset.deliveryTime;
    const string = mtoDeliveryDateNode.dataset.string;
    const weekString = mtoDeliveryDateNode.dataset.weekString;
    const region = mtoDeliveryDateNode.dataset.region;

    const mtoDeliveryDate = getMtoDeliveryDate(
      deliveryTime,
      string,
      weekString,
      region
    );

    mtoDeliveryDateNode.textContent = mtoDeliveryDate;

    
  };

  const init = () => {
    if (!mtoDeliveryDateNode) return;
    setMtoDeliveryDate();
  };

  init();
};
